/* ============================================================
   SIMOVO eSIM Install Guide — interactivity (progressive enhancement)
   The page is fully server-rendered; this script only adds behaviour:
   OS tab switch, animated stepper, FAQ accordion, compatibility modal.
   No dependencies. Re-inits in the theme editor.
   ============================================================ */
(function () {
  "use strict";

  function bindImageFallbacks(scope) {
    scope.querySelectorAll("img[data-fallback]").forEach(function (img) {
      if (img.__svoFb) return; img.__svoFb = true;
      img.addEventListener("error", function () {
        var kind = img.getAttribute("data-fallback");
        if (kind === "ph") { if (img.parentNode) img.parentNode.classList.add("ph"); img.style.display = "none"; }
        else if (kind === "hide") { img.style.display = "none"; }
        else if (kind === "hideop") { img.style.opacity = "0"; }
      });
    });
    scope.querySelectorAll(".phone-shot").forEach(function (img) {
      if (img.__svoShot) return; img.__svoShot = true;
      img.addEventListener("error", function () {
        var screen = img.closest(".phone-screen"); if (screen) screen.classList.add("shot-failed");
      });
    });
  }

  /* ---------------- Stepper ---------------- */
  function initStepper(stepper) {
    var items = Array.prototype.slice.call(stepper.querySelectorAll("[data-svo-step]"));
    if (!items.length) return;
    var dots = stepper.querySelectorAll("[data-svo-dot]");
    var prev = stepper.querySelector("[data-svo-prev]");
    var next = stepper.querySelector("[data-svo-next]");
    var count = stepper.querySelector("[data-svo-count]");
    var phoneWrap = stepper.querySelector("[data-svo-phone]");
    var shot = stepper.querySelector(".phone-shot");
    var shotBg = stepper.querySelector(".phone-shot-bg");
    var total = items.length;
    var totalStr = String(total).padStart(2, "0");
    var active = 0;

    function setBody(li, open) {
      var body = li.querySelector(".rail-body");
      if (!body) return;
      body.style.maxHeight = open ? body.scrollHeight + "px" : "0px";
    }
    function swapPhone(li, dir) {
      var src = li.getAttribute("data-img"), alt = li.getAttribute("data-alt") || "";
      var screen = shot && shot.closest(".phone-screen");
      if (screen) screen.classList.remove("shot-failed");
      if (shot) { shot.src = src; shot.alt = alt; }
      if (shotBg) { shotBg.src = src; }
      if (phoneWrap) {
        phoneWrap.classList.remove("phone-anim", "from-right", "from-left");
        void phoneWrap.offsetWidth; // reflow to replay the entrance
        phoneWrap.classList.add("phone-anim", dir < 0 ? "from-left" : "from-right");
      }
    }
    function go(i, dir) {
      if (i < 0 || i >= total || i === active) return;
      dir = dir || (i > active ? 1 : -1);
      items.forEach(function (li, idx) {
        li.classList.toggle("is-active", idx === i);
        li.classList.toggle("is-done", idx < i);
        setBody(li, idx === i);
      });
      dots.forEach(function (d, idx) { d.classList.toggle("is-on", idx === i); });
      if (count) count.textContent = String(i + 1).padStart(2, "0") + " / " + totalStr;
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === total - 1;
      swapPhone(items[i], dir);
      active = i;
    }

    items.forEach(function (li, i) {
      var head = li.querySelector("[data-svo-step-head]");
      if (head) head.addEventListener("click", function () { go(i); });
    });
    dots.forEach(function (d, i) { d.addEventListener("click", function () { go(i); }); });
    if (prev) prev.addEventListener("click", function () { go(active - 1, -1); });
    if (next) next.addEventListener("click", function () { go(active + 1, 1); });

    // sync the initial (server-rendered) open body to its real height
    setBody(items[0], true);
  }

  /* ---------------- OS tabs ---------------- */
  function initOsTabs(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll("[data-svo-os]"));
    var ind = root.querySelector("[data-svo-os-ind]");
    if (!tabs.length) return;
    function select(os) {
      tabs.forEach(function (t) {
        var on = t.getAttribute("data-svo-os") === os;
        t.classList.toggle("is-on", on);
        t.setAttribute("aria-selected", on ? "true" : "false");
      });
      root.querySelectorAll("[data-svo-panel]").forEach(function (p) {
        var show = p.getAttribute("data-svo-panel") === os;
        p.hidden = !show;
        if (show) { p.classList.remove("fade-in"); void p.offsetWidth; p.classList.add("fade-in"); }
      });
      if (ind) { ind.classList.remove("os-tab-ind--ios", "os-tab-ind--android"); ind.classList.add("os-tab-ind--" + os); }
    }
    tabs.forEach(function (t) { t.addEventListener("click", function () { select(t.getAttribute("data-svo-os")); }); });
  }

  /* ---------------- FAQ accordion (single-open) ---------------- */
  function initAccordion(root) {
    var items = Array.prototype.slice.call(root.querySelectorAll("[data-svo-acc]"));
    function setOpen(item, open) {
      item.classList.toggle("is-open", open);
      var panel = item.querySelector(".acc-panel");
      var sign = item.querySelector(".acc-sign");
      if (panel) panel.style.maxHeight = open ? panel.scrollHeight + "px" : "0px";
      if (sign) sign.innerHTML = open ? "&ndash;" : "+";
    }
    items.forEach(function (item) {
      var head = item.querySelector("[data-svo-acc-head]");
      if (head) head.addEventListener("click", function () {
        var isOpen = item.classList.contains("is-open");
        items.forEach(function (o) { if (o !== item) setOpen(o, false); });
        setOpen(item, !isOpen);
      });
      // sync server-rendered open item to real height
      if (item.classList.contains("is-open")) setOpen(item, true);
    });
  }

  /* ---------------- Compatibility modal ---------------- */
  function initCompat(root) {
    var overlay = root.querySelector("[data-svo-compat]");
    if (!overlay) return;
    var input = overlay.querySelector("[data-svo-compat-input]");
    var clear = overlay.querySelector("[data-svo-compat-clear]");
    var browse = overlay.querySelector("[data-svo-compat-browse]");
    var resultsBox = overlay.querySelector("[data-svo-compat-results]");
    var emptyBox = overlay.querySelector("[data-svo-compat-empty]");

    // build a device index from the server-rendered chips
    var index = [];
    overlay.querySelectorAll(".brand[data-brand]").forEach(function (b) {
      var brand = b.getAttribute("data-brand");
      b.querySelectorAll("[data-device]").forEach(function (chip) {
        index.push({ name: chip.getAttribute("data-device"), brand: brand });
      });
    });

    function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]; }); }

    function open() {
      overlay.hidden = false;
      document.body.style.overflow = "hidden";
      setTimeout(function () { if (input) input.focus(); }, 60);
    }
    function close() {
      overlay.hidden = true;
      document.body.style.overflow = "";
    }
    function toggleBrand(b) {
      var isOpen = b.classList.toggle("is-open");
      var panel = b.querySelector(".brand-panel");
      if (panel) panel.style.maxHeight = isOpen ? panel.scrollHeight + "px" : "0px";
    }
    function runSearch() {
      var q = (input && input.value || "").trim().toLowerCase();
      if (clear) clear.hidden = !q;
      if (!q) { browse.hidden = false; resultsBox.hidden = true; emptyBox.hidden = true; return; }
      browse.hidden = true;
      var byBrand = {};
      index.forEach(function (d) {
        if (d.name.toLowerCase().indexOf(q) > -1) { (byBrand[d.brand] = byBrand[d.brand] || []).push(d.name); }
      });
      var brands = Object.keys(byBrand);
      if (!brands.length) { resultsBox.hidden = true; emptyBox.hidden = false; return; }
      emptyBox.hidden = true; resultsBox.hidden = false;
      resultsBox.innerHTML = brands.map(function (br) {
        return '<div class="result-brand"><p class="result-brand-name">' + esc(br) + '</p><div class="chiprow">' +
          byBrand[br].map(function (n) { return '<span class="chip chip--ok"><span class="chip-tick">&#10003;</span>' + esc(n) + '</span>'; }).join("") +
          '</div></div>';
      }).join("") + '<p class="compat-okline">These models are <strong>eSIM compatible</strong> \u2014 just make sure your device is carrier&nbsp;unlocked.</p>';
    }

    root.querySelectorAll("[data-svo-open-compat]").forEach(function (btn) {
      btn.addEventListener("click", function (e) { e.preventDefault(); open(); });
    });
    overlay.querySelectorAll("[data-svo-compat-close]").forEach(function (b) { b.addEventListener("click", close); });
    overlay.addEventListener("mousedown", function (e) { if (e.target === overlay) close(); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !overlay.hidden) close(); });
    overlay.querySelectorAll("[data-svo-brand-head]").forEach(function (h) {
      h.addEventListener("click", function () { toggleBrand(h.closest(".brand")); });
    });
    if (input) input.addEventListener("input", runSearch);
    if (clear) clear.addEventListener("click", function () { if (input) input.value = ""; runSearch(); if (input) input.focus(); });
  }

  function init(root) {
    if (!root || root.__svoGuide) return;
    root.__svoGuide = true;
    bindImageFallbacks(root);
    root.querySelectorAll("[data-svo-stepper]").forEach(initStepper);
    initOsTabs(root);
    initAccordion(root);
    initCompat(root);
  }

  function boot() { document.querySelectorAll(".svo-guide[data-svo-root]").forEach(init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", function (e) {
    var r = e.target.querySelector ? e.target.querySelector(".svo-guide[data-svo-root]") : null;
    if (r) { r.__svoGuide = false; init(r); }
  });
})();
